module.exports = __webpack_public_path__ + "static/img/loading.f0824132.gif";